import Vue from 'vue'
import SvgIcon from '../components/SvgIcon.vue'

import tblBtnIcon from '@/components/tblBtncomponents.vue'
import tblcomponents from '@/components/tblcomponents.vue'

Vue.component('svg-icon', SvgIcon)
Vue.component('tbl-btn-icon', tblBtnIcon)
Vue.component('tblcomponents', tblcomponents)

const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /\.svg$/)
requireAll(req)
